import React from 'react'
import classNames from 'classnames'
import css from './Clover.styles.scss'
import { ShapeProps } from '../../FloatingShapesBackground.types'

const Clover: React.FC<ShapeProps> = ({ animated }) => (
  <svg
    className={classNames(css.Clover, {
      [css.Clover__Animated]: animated,
    })}
    fill="none"
    height="140"
    id="clover"
    viewBox="0 0 180 180"
    width="140"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.8813 90.0001C15.7772 89.8976 15.6734 89.7946 15.5699 89.6912C-5.06873 69.0526 -5.20702 35.729 15.261 15.261C35.729 -5.20702 69.0526 -5.06872 89.6912 15.5699C89.7946 15.6734 89.8976 15.7772 90.0001 15.8813C90.1025 15.7772 90.2054 15.6735 90.3088 15.57C110.947 -5.06855 144.271 -5.20685 164.739 15.2612C185.207 35.7292 185.069 69.0527 164.43 89.6913C164.358 89.7632 164.286 89.8348 164.214 89.9062C164.182 89.9376 164.151 89.9689 164.119 90.0002C164.223 90.1026 164.327 90.2056 164.43 90.3091C185.069 110.948 185.207 144.271 164.739 164.739C144.271 185.207 110.947 185.069 90.3088 164.43C90.2054 164.327 90.1024 164.223 90 164.119C89.8976 164.223 89.7946 164.327 89.6912 164.43C69.0526 185.069 35.7291 185.207 15.2611 164.739C-5.20693 144.271 -5.06866 110.948 15.5699 90.3089C15.6734 90.2055 15.7772 90.1025 15.8813 90.0001Z"
      fill="url(#paint0_linear_4569_48395)"
    />
    <path
      d="M15.8813 90.0001C15.7772 89.8976 15.6734 89.7946 15.5699 89.6912C-5.06873 69.0526 -5.20702 35.729 15.261 15.261C35.729 -5.20702 69.0526 -5.06872 89.6912 15.5699C89.7946 15.6734 89.8976 15.7772 90.0001 15.8813C90.1025 15.7772 90.2054 15.6735 90.3088 15.57C110.947 -5.06855 144.271 -5.20685 164.739 15.2612C185.207 35.7292 185.069 69.0527 164.43 89.6913C164.358 89.7632 164.286 89.8348 164.214 89.9062C164.182 89.9376 164.151 89.9689 164.119 90.0002C164.223 90.1026 164.327 90.2056 164.43 90.3091C185.069 110.948 185.207 144.271 164.739 164.739C144.271 185.207 110.947 185.069 90.3088 164.43C90.2054 164.327 90.1024 164.223 90 164.119C89.8976 164.223 89.7946 164.327 89.6912 164.43C69.0526 185.069 35.7291 185.207 15.2611 164.739C-5.20693 144.271 -5.06866 110.948 15.5699 90.3089C15.6734 90.2055 15.7772 90.1025 15.8813 90.0001Z"
      fill="url(#paint1_radial_4569_48395)"
    />
    <path
      d="M15.8813 90.0001C15.7772 89.8976 15.6734 89.7946 15.5699 89.6912C-5.06873 69.0526 -5.20702 35.729 15.261 15.261C35.729 -5.20702 69.0526 -5.06872 89.6912 15.5699C89.7946 15.6734 89.8976 15.7772 90.0001 15.8813C90.1025 15.7772 90.2054 15.6735 90.3088 15.57C110.947 -5.06855 144.271 -5.20685 164.739 15.2612C185.207 35.7292 185.069 69.0527 164.43 89.6913C164.358 89.7632 164.286 89.8348 164.214 89.9062C164.182 89.9376 164.151 89.9689 164.119 90.0002C164.223 90.1026 164.327 90.2056 164.43 90.3091C185.069 110.948 185.207 144.271 164.739 164.739C144.271 185.207 110.947 185.069 90.3088 164.43C90.2054 164.327 90.1024 164.223 90 164.119C89.8976 164.223 89.7946 164.327 89.6912 164.43C69.0526 185.069 35.7291 185.207 15.2611 164.739C-5.20693 144.271 -5.06866 110.948 15.5699 90.3089C15.6734 90.2055 15.7772 90.1025 15.8813 90.0001Z"
      fill="url(#paint2_radial_4569_48395)"
    />
    <defs>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint0_linear_4569_48395"
        x1="-2.9628e-07"
        x2="180"
        y1="180"
        y2="-0.000215826"
      >
        <stop offset="0.1" stopColor="#FF6D4E" />
        <stop offset="0.9" stopColor="#FFD43E" />
      </linearGradient>
      <radialGradient
        cx="0"
        cy="0"
        gradientTransform="translate(-4.76962e-07 180) rotate(-45) scale(127.279 127.279)"
        gradientUnits="userSpaceOnUse"
        id="paint1_radial_4569_48395"
        r="1"
      >
        <stop offset="0.249314" stopColor="#FF6D4E" />
        <stop offset="1" stopColor="#FF6D4E" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        cx="0"
        cy="0"
        gradientTransform="rotate(45) scale(127.279 127.279)"
        gradientUnits="userSpaceOnUse"
        id="paint2_radial_4569_48395"
        r="1"
      >
        <stop offset="0.251937" stopColor="#FED7FF" />
        <stop offset="1" stopColor="#FED7FF" stopOpacity="0" />
      </radialGradient>
    </defs>
  </svg>
)

export default Clover
